import React from "react";

// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import TextInput from "../widgets/TextInput";
import FixButton from "../widgets/Button";
import getStipendio from "../services/getStipendio";
import Loading from "../components/Loading";
import StipendiComponent from "../components/StipendiComponent";
import moment from "moment";
import editStipendio from "../services/editStipendio";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class EditStipendio extends React.Component {

constructor(props){
    super (props)

    let emptyStipendio = {
        data: '', 
        importo: ''
    }
    this.emptyStipendi = [
        ["2022", emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio], 
        ["2023", emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio], 
        ["2024", emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio], 
        ["2025", emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio, emptyStipendio], 
    ]

    this.state = {
        isLoading: true, 
        dipendente: '',
        stipendio: '', 
        numeroMensilita: 12,
        idStipendio: undefined,
        stipendi: this.emptyStipendi,
    };

}

async componentDidMount() {

    username = cookies.get('username', { path: '/' });
    token = cookies.get('token', { path: '/' });

    let current = cookies.get('stipendio', { path: '/' });
    let stipendio = await getStipendio(username, token, current);

    this.setState({
        isLoading: false, 
        idStipendio: stipendio.id,
        dipendente: stipendio.dipendente,  
        stipendio: stipendio.stipendio_base, 
        numeroMensilita: parseInt(stipendio.mensilita),
        stipendi: stipendio.stipendio_custom ? JSON.parse(stipendio.stipendio_custom) : this.emptyStipendi, 
    });
}

setBaseStipendio(stipendio) {
    var stipendi = this.state.stipendi;
    stipendi.forEach((s, ind) => {
        s.forEach((mese, i) => {
            if (i !== 0) {
                if (moment(mese.data, 'DD/MM/yyyy').endOf('day').isSameOrAfter(moment()) && stipendi[ind][i].importo === this.state.stipendio) {
                    stipendi[ind][i].importo = stipendio;
                }
            }
        });
    });

    this.setState({ stipendi });
}

render () {
    if (this.state.isLoading)
        return <Loading />;

    return (
    <>
        <PageTitle title={'Modifica stipendio'} />  

        <TextInput name={'Nome e cognome dipendente'} value={this.state.dipendente} 
            onChange={(text) => { this.setState({dipendente: text})}
        } />

        <TextInput noState={true} name={'Stipendio base (mensile) del dipendente'} value={this.state.stipendio}
            onChange={(text) => {
                var t = text.replace(/\./g, '');
                if(/[^0-9,]+/.test(t)) {
                    t = t.replace(/[^0-9]+/g, '');
                }
                var chunks = t.split(',');
                chunks[0] = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                t = chunks.join(',');
                this.setBaseStipendio(t.trim());
                this.setState({stipendio: t.trim()});
            }}
        />

        {/*
        <TextNumberInput name={'Mensilità'} value={this.state.numeroMensilita} 
            onChange={(text) => { this.setState({numeroMensilita: parseInt(text)})}
        } />
        */}

        <div style={{ height: 30 }} />

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left', flexDirection: 'row', marginTop: 20 }}>
            <h3 style={{marginLeft: 5, marginTop: 15}}>Stipendi</h3>
        </div>
        <StipendiComponent passati={false} stipendi={this.state.stipendi} importo={this.state.nextStipendioImporto} data={this.state.nextStipendioDate} onStipendioChange={(text) => this.setState({nextStipendioImporto: text.trim()})} onChange={(stipendi) => this.setState({ stipendi })} />

        <div style={{ height: 30 }} />
        <FixButton title={'Salva'} callback={() => this.save()} />
    </>
    );
}

    async save() {

        this.setState({ isLoading: true });

        if (!this.state.dipendente) {
            alert('Inserire un nome valido per il dipendente');
            return;
        }

        if (!this.state.stipendio) {
            alert('Inserire uno stipendio mensile base valido per proseguire.');
            return;
        }

        if (this.state.numeroMensilita > 15 || this.state.numeroMensilita < 12) {
            alert('Inserire un numero di mensilità compreso tra 12 e 15.');
            return;
        }

        let stipendio = {
            id: this.state.idStipendio,
            dipendente: this.state.dipendente, 
            stipendio: this.state.stipendio, 
            mensilita: this.state.numeroMensilita, 
            custom: JSON.stringify(this.state.stipendi),
        };

        let res = await editStipendio(username, token, stipendio);
        if (res.result === 'ok') {
            window.location.href = '/#/app/stipendi';
            return;
        }

        this.setState({ isLoading: false });
        alert('Si è verificato un errore durante la creazione dello stipendio. Per favore, riprova.');
    }

}

// const selectionButton = {
//     height: 30,
//     width: 140,
//     marginLeft: 5,
//     borderTopLeftRadius: 15,
//     borderBottomLeftRadius: 15,
//     textAlign: 'center',
//     paddingTop: 4,
//     cursor: 'pointer'
// }

// const rightSelectionButton = {
//     height: 30,
//     width: 140,
//     marginLeft: 5,
//     borderTopRightRadius: 15,
//     borderBottomRightRadius: 15,
//     textAlign: 'center',
//     paddingTop: 4,
//     cursor: 'pointer'
// }

